module.exports = __webpack_public_path__ + "img/non-veg-sticky.e2e353f1.svg";